import { useCallback, useEffect, useRef, useState } from "react";
import { errorDeApi, infoDe } from "./clientesUtils";

/**
 * Loads `fn()` (an axios call whose `data.info` is the result) on mount and whenever `clave` changes.
 * `valida(info)` rejects a payload that is not the contract's. An older response never overwrites a newer one.
 * Returns `{ loading, error: { message, codigo, status } | null, data, setData, reload }`.
 */
export default function useCarga(fn, clave, { valida = () => true, mensaje = "No pudimos cargar los datos. Probá de nuevo." } = {}) {
  const [state, setState] = useState({ loading: true, error: null, data: null });
  const pedido = useRef(0);
  const fnRef = useRef(fn);
  fnRef.current = fn;
  const validaRef = useRef(valida);
  validaRef.current = valida;

  const cargar = useCallback(async () => {
    const id = ++pedido.current;
    setState((prev) => ({ loading: true, error: null, data: prev.data }));
    try {
      const info = infoDe(await fnRef.current());
      if (!info || !validaRef.current(info)) throw new Error("Invalid response");
      if (id === pedido.current) setState({ loading: false, error: null, data: info });
    } catch (e) {
      if (id === pedido.current) setState((prev) => ({ loading: false, error: errorDeApi(e, mensaje), data: prev.data }));
    }
  }, [mensaje]);

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave, cargar]);

  const setData = useCallback((updater) => setState((prev) => ({ ...prev, data: typeof updater === "function" ? updater(prev.data) : updater })), []);

  return { ...state, setData, reload: cargar };
}
